"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ArrayValue;
const react_1 = __importDefault(require("react"));
const is_object_1 = __importDefault(require("is-object"));
const mui_1 = require("tss-react/mui");
// locals
const Attributes_1 = __importDefault(require("./Attributes"));
const FieldName_1 = __importDefault(require("./FieldName"));
const BasicValue_1 = __importDefault(require("./BasicValue"));
const useStyles = (0, mui_1.makeStyles)()(theme => ({
    field: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    fieldSubvalue: {
        wordBreak: 'break-word',
        maxHeight: 300,
        padding: theme.spacing(0.5),
        border: `1px solid ${theme.palette.action.selected}`,
        boxSizing: 'border-box',
        overflow: 'auto',
    },
}));
function ArrayValue({ name, value, description, prefix = [], }) {
    const { classes } = useStyles();
    if (value.length === 1) {
        return (0, is_object_1.default)(value[0]) ? (react_1.default.createElement(Attributes_1.default, { attributes: value[0], prefix: [...prefix, name] })) : (react_1.default.createElement("div", { className: classes.field },
            react_1.default.createElement(FieldName_1.default, { prefix: prefix, description: description, name: name }),
            react_1.default.createElement(BasicValue_1.default, { value: value[0] })));
    }
    else if (value.every(val => (0, is_object_1.default)(val))) {
        return (react_1.default.createElement(react_1.default.Fragment, null, value.map((val, i) => (react_1.default.createElement(Attributes_1.default, { key: JSON.stringify(val) + '-' + i, attributes: val, prefix: [...prefix, name + '-' + i] })))));
    }
    else {
        return (react_1.default.createElement("div", { className: classes.field },
            react_1.default.createElement(FieldName_1.default, { prefix: prefix, description: description, name: name }),
            value.map((val, i) => (react_1.default.createElement("div", { key: JSON.stringify(val) + '-' + i, className: classes.fieldSubvalue },
                react_1.default.createElement(BasicValue_1.default, { value: val }))))));
    }
}
